import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/movies", label: "电影" },
  { to: "/tvshows", label: "电视剧" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-medium transition-colors duration-200 ${
      isActive
        ? "text-primary-500"
        : "text-foreground-600 hover:text-foreground-950"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/60 bg-background-50/90 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-film-fill text-lg"></i>
          </span>
          <span className="font-heading text-base font-bold leading-none tracking-tight text-foreground-950 md:text-lg">
            免费观看大片<span className="text-primary-500">在线观看</span>
          </span>
        </Link>

        <nav className="ml-2 hidden items-center md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden w-44 md:block lg:w-72">
          <div className="relative">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="搜索电影、电视剧、演员"
              className="w-full rounded-full border border-background-200/70 bg-background-100/80 py-2 pl-9 pr-4 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-500/30"
            />
          </div>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/60 md:hidden"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>

      </div>

      <div className="border-t border-background-200/50 px-4 py-2.5 md:hidden">
        <form onSubmit={handleSearch}>
          <div className="relative">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="搜索电影、电视剧"
              className="w-full rounded-full border border-background-200/70 bg-background-100/80 py-2 pl-9 pr-4 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-500/30"
            />
          </div>
        </form>
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200/50 bg-background-50 px-4 py-2 md:hidden">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `block rounded-md px-3 py-3 text-sm font-medium ${
                  isActive
                    ? "bg-primary-100/70 text-primary-700"
                    : "text-foreground-700 hover:bg-background-200/60"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}